export const priceFormat = number =>
  new Intl.NumberFormat('pt-BR').format(number)
